<template>
  <div>
    <p v-if="setupMode">
      You have provided all the required information! Please
      <a
        :href="$root.baseSupportUrl"
        v-text="'contact support'"
      />
      for next steps.
    </p>
    <p
      v-else
      v-text="'Your payment account does not require any action, but you can use the link below to edit your account information.'"
    />
    <div>
      <button
        type="button"
        class="btn btn--sm"
        :disabled="loading"
        :aria-disabled="loading"
        @click="editExistingInfo"
        v-text="'Edit Account Information'"
      />
    </div>
  </div>
</template>

<script type="text/babel">
import { mapActions } from 'vuex'

export default {
  name: 'NoRequirements',
  props: {

    setupMode: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions([
      'getAccountLink',
    ]),
    async editExistingInfo() {
      this.loading = true

      window.location = await this.getAccountLink()

      this.loading = false
    },
  },
}
</script>
